/**
 * Constants used in application
 */
export const CONSTANTS = {
  KEEP_ALIVE: 'KEEP_ALIVE',
  LOGOUT: 'LOGOUT',
  SUCCESS: 'SUCCESS',
  TRN_WARNING: 'TRN_WARNING',
  PARTIAL_FAILURE: 'PARTIAL_FAILURE',
  TRN_ERROR: 'TRN_ERROR',
  TRN_EXCEPTION: 'TRN_EXCEPTION',
  AUTH_TOKEN: 'authToken',
  GET_INVENTORY: 'GET_INVENTORY',
  AUTH_TOKEN_INVALID: 'AUTH_TOKEN_INVALID',
  LOV: 'LOV',
  HRCHY: 'HRCHY',
  DEFAULT_SELECT_VALUE: null,
  DENIED: 'DENIED',
  SUBMITTED : 'SUBMITTED',
  ERROR_MESSAGE: `An error has occurred while processing your request.
            Please try your action again.
            If the problem persists, please contact NJIIS helpdesk.`,
  FACILITY_HRCHY_AF: 'AF',
  FACILITY_HRCHY_SYSTEM: 'SYSTEM',
  FACILITY_HRCHY_GROUP: 'GROUP',
  FACILITY_HRCHY_VENDOR: 'VENDOR',
  FACILITY_HRCHY_HUB: 'HUB',
  FACILITY_HRCHY_SFTP_ACCOUNT: 'SFTP_ACCOUNT_ID',
  ADD: 'ADD',
  YES: 'YES',
  NO: 'NO',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  DISCARD_CHANGES_MSG: 'Discard Changes?',
  NO_CHANGES_MADE_MSG: 'No changes made',
  NJIIS_ERROR: `An error has occurred while processing your request.
  Please try your action again. If the problem persists, please contact NJIIS helpdesk.`,
  ERROR: 'ERROR',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  REVIEW: 'REVIEW',
  ALL_DENIED: 'allDenied',
  ALLOWED: 'ALLOWED',
  CATEGORY: 'CATEGORY',
  SEND_EMAIL: 'EMAIL',
  PARTIALLY_ADMINISTERED_WARNING:
    'If your facility is using the NJIIS inventory (VFC/317 providers), you must document the Partially Administered dose as a wastage.',
  ADD_DOSE: 'ADD_DOSE',
  DELETE_DOSE: 'DELETE_DOSE',
  DIALOG_TITLE_SUCCESS: 'Success',
  DIALOG_TITLE_WARNING: 'Warning',
  DIALOG_TITLE_INFO: 'Info',
  DIALOG_TITLE_ERROR: 'Error',
  UPDATE_DOSE: 'UPDATE_DOSE',
  DELETE_AND_ADD_DOSE: "DELETE_AND_ADD_DOSE",
  DOSE_GIVEN_NOT_FOUND: 'DOSE_GIVEN_NOT_FOUND',
  REVACCINATE_DOSE: 'REVACCINATE_DOSE',
  MAX_HISTORY_DOSES_LIST: [0, 1, 2],
  HISTORY_DOSE: 'HISTORY_DOSE',
  SCHOOL_HISTORY_FACILITY: '1216',
  HISTORY_FACILITY: '396',
  ACCESS_DENIED: 'ACCESS DENIED',
  PASSWORD_EXPIRED_MSG: 'YOUR PASSWORD HAS EXPIRED. RESET PASSWORD TO LOGIN',
  IN_PROGRESS: 'IN_PROGRESS',
  TRN_IN_PROGRESS: 'TRN_IN_PROGRESS',
  COVID_BASE_URL: '/covid/',
  USER_CONF_AGREEMENT_NOT_COMPLETE: 'USER CONFIDENTIAL AGREEMENT NOT COMPLETE',
  ADD_ADVERSE_EVENT: 'ADD_ADVERSE_EVENT',
  EDIT_ADVERSE_EVENT: 'EDIT_ADVERSE_EVENT',
  ADD_COVID_REMINDER_RECALL: 'ADD_COVID_RR',
};

/**
 * Type of alerts
 */
export const ALERT_TYPE = {
  ERROR: 'danger',
  WARNING: 'warning',
  SUCCESS: 'success',
};

/**
 * List of components
 */
export const COMPONENTS = {
  FACILITY: {
    ADD_FACILITY: 'ADD FACILITY',
    UPDATE_FACILITY: 'UPDATE FACILITY',
    VIEW_FACILITY: 'VIEW FACILITY',
    ADD_CONTACT: 'ADD CONTACT',
    UPDATE_CONTACT: 'UPDATE CONTACT',
    VIEW_CONTACT: 'VIEW CONTACT',
    UPDATE_ADDRESS: 'UPDATE ADDRESS',
    VIEW_ADDRESS: 'VIEW ADDRESS',
    ADD_AUDIT_REVIEW: 'ADD AUDIT REVIEW',
    UPDATE_AUDIT_REVIEW: 'UPDATE AUDIT REVIEW',
    VIEW_AUDIT_REVIEW: 'VIEW AUDIT REVIEW',
    ADD_INTERFACE_PROFILE: 'ADD INTERFACE PROFILE',
    UPDATE_INTERFACE_PROFILE: 'UPDATE INTERFACE PROFILE',
    VIEW_INTERFACE_PROFILE: 'VIEW INTERFACE PROFILE',
    ADD_VFC: 'ADD VFC',
    UPDATE_VFC: 'UPDATE VFC',
    VIEW_VFC: 'VIEW VFC',
    VIEW_FACILITY_USERS: 'VIEW FACILITY USERS',
  },
  INVENTORY: {
    MANAGE_INVENTORY: 'MANAGE INVENTORY',
    MANAGE_TRANSACTION: 'MANAGE TRANSACTION',
    VIEW_INVENTORY: 'VIEW INVENTORY',
    VIEW_TRANSACTION: 'VIEW TRANSACTION',
  },
  SYSTEM: {
    ADD_SYSTEM: 'ADD SYSTEM',
    UPDATE_SYSTEM: 'UPDATE SYSTEM',
    VIEW_SYSTEM: 'VIEW SYSTEM',
  },
  GROUP: {
    ADD_GROUP: 'ADD FACILITY GROUP',
    UPDATE_GROUP: 'UPDATE FACILITY GROUP',
    VIEW_GROUP: 'VIEW FACILITY GROUP',
  },
  PATIENT: {
    MANAGE_PATIENT: 'MANAGE PATIENT',
    MANAGE_PERSONAL_INFORMATION: 'MANAGE PERSONAL INFORMATION',
    UPDATE_CRITICAL_INFORMATION: 'UPDATE CRITICAL INFORMATION',
    VIEW_SCHEDULER_DETAIL: 'VIEW SCHEDULER DETAIL',
    VIEW_PERSONAL_INFORMATION: 'VIEW PERSONAL INFORMATION',
    VIEW_PATIENT_INFORMATION: 'VIEW PATIENT INFORMATION',
    VIEW_PATIENT: 'VIEW PATIENT',
    VIEW_NOTE: 'VIEW NOTE',
    VIEW_MEDICAL_HISTORY: 'VIEW MEDICAL HISTORY',
    VIEW_IMMUNIZATION_RECORD: 'VIEW IMMUNIZATION RECORD',
    VIEW_UNIVERSAL_CHILD_HEALTH_RECORD: 'VIEW UNIVERSAL CHILD HEALTH RECORD',
    VIEW_FOLLOW_UP: 'VIEW FOLLOW UP',
    VIEW_DOSE: 'VIEW DOSE',
    VIEW_CRITICAL_INFORMATION: 'VIEW CRITICAL INFORMATION',
    VIEW_ALIASES: 'VIEW ALIASES',
    UPDATE_PATIENT_INFORMATION: 'UPDATE PATIENT INFORMATION',
    TRANSFER_STUDENTS: 'TRANSFER STUDENTS',
    MANAGE_SCHOOL_CHILD_CARE: 'MANAGE SCHOOL CHILD CARE',
    MANAGE_PATIENT_STATUS: 'MANAGE PATIENT STATUS',
    MANAGE_NOTE: 'MANAGE NOTE',
    MANAGE_MEDICAL_HISTORY: 'MANAGE MEDICAL HISTORY',
    MANAGE_FOLLOW_UP: 'MANAGE FOLLOW UP',
    MANAGE_DOSE: 'MANAGE DOSE',
    MANAGE_ALIASES: 'MANAGE ALIASES',
    EHDI_VIEW_LOST_TO_FOLLOWUP: 'EHDI VIEW LOST TO FOLLOWUP',
    EHDI_VIEW_FOLLOWUP_CONTACT: 'EHDI VIEW FOLLOWUP CONTACT',
    EHDI_VIEW_FOLLOWUP_REPORT: 'EHDI VIEW FOLLOWUP REPORT',
    CHANGE_CONSENT: 'CHANGE CONSENT',
    VIEW_CONSENT: 'VIEW_CONSENT',
    MANAGE_CONTRAINDICATION: 'MANAGE CONTRAINDICATION',
    VIEW_CONTRAINDICATION: 'VIEW CONTRAINDICATION',
    MANAGE_PATIENT_ADDRESS: 'MANAGE PATIENT ADDRESS',
    VIEW_PATIENT_ADDRESS: 'VIEW PATIENT ADDRESS',
    HISTORY: 'HISTORY',
    VIEW_SERIES_SUMMARY: 'VIEW SERIES SUMMARY',
    EHDI_MANAGE_LOSTTO_FOLLOWUP: 'EHDI MANAGE LOST TO FOLLOWUP',
    EHDI_MANAGE_FOLLOWUP_REPORT: 'EHDI MANAGE FOLLOWUP REPORT',
    EHDI_MANAGE_FOLLOWUP_CONTACT: 'EHDI MANAGE FOLLOWUP CONTACT',
    CHANGE_FOLLOWUP_FACILITY_OF_RECORD: 'Change Followup Facility of Record',
    VIEW_SCHOOL_CHILD_CARE: 'VIEW SCHOOL CHILD CARE',
  },
  USER: {
    UPDATE_USER: 'UPDATE USER',
    ADMIN_EDIT_TRAINING: 'ADMIN EDIT TRAINING',
  },
  TEMPERATURELOG: {
    MANAGE_UNIT: 'MANAGE UNIT',
    MANAGE_TEMPERATURE_LOG: 'MANAGE TEMPERATURE LOG',
  },
  VACCINE_ORDERING: {
    MANAGE_ORDER: 'MANAGE ORDER',
    MANAGE_VACCINE_RESTRICTIONS: 'MANAGE VACCINE RESTRICTIONS',
    MANAGE_VACCINE_LIST: 'MANAGE VACCINE LIST',
    FACILITY_TYPE_SETUP: 'PROVIDER TYPE SETUP',
    IMM48: 'IMM 48',
    MANAGE_IMM48: 'MANAGE IMM 48',
  },
  VENDOR: {
    ADD_VENDOR: 'ADD VENDOR',
    UPDATE_VENDOR: 'UPDATE VENDOR',
    VIEW_VENDOR: 'VIEW VENDOR',
  },
  INTERFACE: {
    ADD_ENTITY: 'ADD INTERFACE ENTITY',
    UPDATE_ENTITY: 'UPDATE INTERFACE ENTITY',
    VIEW_ENTITY: 'VIEW INTERFACE ENTITY',
  },
  REMINDER_RECALL: {
    MANAGE_REMINDER_RECALL: 'MANAGE REMINDER RECALL',
    VIEW_REMINDER_RECALL: 'VIEW REMINDER RECALL',
  },
  COVID: {
    VACCINE_ENROLLMENT: 'VACCINE ENROLLMENT',
    VACCINE_ENROLLMENT_MANAGEMENT: 'VACCINE ENROLLMENT MANAGEMENT',
    COVID_ORDER: 'COVID ORDER',
    COVID_VACCINE_RESTRICTIONS: 'COVID VACCINE RESTRICTIONS',
    COVID_FACILITY_TYPE_SETUP: 'COVID FACILITY TYPE SETUP',
    MULTIPLE_ORDERS: 'MULTIPLE ORDERS',
    UPLOAD_KPI: 'UPLOAD KPI',
    IMM48: 'COVID-19 IMM 48',
    MANAGE_IMM48: 'MANAGE COVID-19 IMM 48',
  },
  STATEFUND: {
    STATEFUND_VACCINE_RESTRICTIONS: 'STATE FUNDED RESTRICTIONS',
    STATEFUND_VACCINE_LIST: 'STATE FUNDED VACCINES LIST',
    MULTIPLE_ORDERS: 'MULTIPLE ORDERS',
    STATEFUND_FACILITY_TYPE_SETUP: 'STATE FUNDED FACILITY TYPE SETUP',
    MANAGE_IMM48: 'MANAGE STATE FUND IMM 48',
    IMM48: 'STATE FUNDED IMM 48',
    STATEFUND_ORDER: 'STATE FUND ORDER'
  },
  FORMS: {
    IMM48: 'IMM 48',
    MONKEYPOX_AGREEMENT: 'MONKEYPOX AGREEMENT',
  },
  TRAINING_VIDEOS: {
    COVID19_ON_DEMAND_TRAINING: 'COVID-19 ON-DEMAND TRAINING',
    INTERFACE_WEBINAR_TRAINING_VIDEOS: 'INTERFACE WEBINAR',
  },
};

/**
 * Dropdown sort Type
 */
export const DROPDOWN_SORT = {
  /**
   * Sort by descr property
   */
  DESCR: 'DESCR',

  /**
   * push UNKNOWN to end
   */
  UNKNOWN_AT_END: 'UNKNOWN_AT_END',

  /**
   * Sort by displayOrder property
   */
  DISPLAY_ORDER: 'DISPLAY_ORDER',

  /**
   * Sort by intfc_entity_name property
   */
  INTFC_ENTITY_NAME: 'INTFC_ENTITY_NAME',

  INSURANCE_NAME: 'INSURANCE_NAME',
  DISPLAY_NAME: 'DISPLAY_NAME',
};

/**
 * Address Type used in application
 */
export const ADDRESS_TYPE = {
  /**
   * Business type used in Facility Address
   */
  BUSINESS: 'BUSINESS',

  /**
   * VFC Office Info
   */
  SHIPPING: 'SHIPPING',

  COVID_SHIPPING: 'COVID SHIPPING',

  COVID_RECIPIENT: 'COVID RECIPIENT',

  STATE_SHIPPING: 'STATE SHIPPING',

  STATE_RECIPIENT: 'STATE RECIPIENT',

  PHYSICAL: 'PHYSICAL',
};

/**
 * Email Type
 */
export const EMAIL_TYPE = {
  /**
   * Work is used in Facility Contact
   */
  WORK: 'WORK',

  /**
   * Used in VFC Office Information
   */
  SHIPPING: 'SHIPPING',

  HOME: 'HOME',

  COVID_SHIPPING: 'COVID SHIPPING',

  STATE_SHIPPING: 'STATE SHIPPING'
};

/**
 * Types of phone (column values)
 */
export const PHONE_TYPE = {
  WORK: '2',
  FAX: '4',
  SHIPPING: '6',
  CELL: '3',
  HOME: '1',
  WORK_CELL: '28',
  WORK_PHONE: '2',
  COVID_SHIPPING: '35',
  COVID_RECIPIENT: '33',
  STATE_SHIPPING: '39',
  STATE_RECIPIENT: '37',
};

/**
 * Types of Fax (column value)
 */
export const FAX_TYPE = {
  SHIPPING: '7',
  COVID_SHIPPING: '36',
  COVID_RECIPIENT: '34',
  STATE_SHIPPING: '40',
  STATE_RECIPIENT: '38',
};

/**
 * Modal dialog status
 */
export const MODAL_DIALOG_STATUS = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  INFO: 'Info',
  WARNING: 'Warning',
};

/**
 * Interface access type
 */
export const INTFC_ACCESS_TYPE = {
  SUBMIT: '1',
  QUERY: '2',
  BIDIRECTIONAL: '3',
};

/**
 * Interface Enrollment access type
 */
 export const INTFC_ENROLL_ACCESS_TYPE = {
  SUBMIT: '1', 
  QUERY: '2',
  BIDIRECTIONAL: '3',
};
/**
 * Interface Type Constants
 */
export const INTFC_TYPE = {
  SFTP: '1',
  FILE_UPLOAD: '2',
  WEBSERVICE: '3',
};
/**
 * Interface Engine Constants
 */
export const INTFC_ENGINE = {
  RHAPSODY: '2',
};

/**
 * File Type constants
 */
export const FILE_TYPE = {
  HL7: 'HL7',
  EXCEL: 'EXCEL',
};

/**
 * HL7 File Version Constants
 */
export const HL7_FILE_VERSION = {
  HL7251: '2',
};

/**
 * GET API names
 */
export const OPERATION = {
  INVENTORY: {
    GET_INVENTORY_TXN_DETAILS: 'GET_INVENTORY_TXN_DETAILS',
    GET_FACILITY_VTRCKS_SHIPMENT: 'GET_FACILITY_VTRCKS_SHIPMENT',
    GET_ORDER_SHIPMENT_UPDATE_STATUS: 'GET_ORDER_SHIPMENT_UPDATE_STATUS',
  },
  FACILITY: {
    GET_FACILITY_TYPE: 'GET_FACILITY_TYPE',
    SEARCH_FACILITY: 'SEARCH_FACILITY',
    GET_INTERFACE_PROFILE: 'GET_INTERFACE_PROFILE',
    CREATE_FACILITY: 'CREATE_FACILITY',
    GET_FACILITY: 'GET_FACILITY',
    GET_FACILITY_GENERAL_INFO: 'GET_FACILITY_GENERAL_INFO',
    UPDATE_FACILITY: 'UPDATE_FACILITY',
    SEARCH_INTERFACE_ENTITY: 'SEARCH_INTERFACE_ENTITY',
    CREATE_INTERFACE_PROFILE: 'CREATE_INTERFACE_PROFILE',
    UPDATE_INTERFACE_PROFILE: 'UPDATE_INTERFACE_PROFILE',
    GET_FACILITY_USER: 'GET_FACILITY_USER',
    GET_FACILITY_NAME: 'GET_FACILITY_NAME',
    GET_VENDOR: 'GET_VENDOR',
    GET_INTERFACE_ENTITY: 'GET_INTERFACE_ENTITY',
  },
  VFC: {
    GET_VFC: 'GET_VFC',
    GET_VFC_INPROGRESS: 'GET_VFC_INPROGRESS',
    GET_VFC_VACC_ENROLL_ORG_IDENTIFICATION: 'GET_VFC_VACC_ENROLL_ORG_IDENTIFICATION',
    GET_VFC_VACCINE_OFFERED: 'GET_VFC_VACCINE_OFFERED',
    GET_VFC_VACCINE_COORDINATOR: 'GET_VFC_VACCINE_COORDINATOR',
    GET_VFC_THERMOMETER: 'GET_VFC_THERMOMETER',
    GET_VFC_FACILITY_STORAGE: 'GET_VFC_FACILITY_STORAGE',
    GET_VFC_OFFICE: 'GET_VFC_OFFICE',
    GET_VFC_VACCINE_DELIVERY_SCHEDULE: 'GET_VFC_VACCINE_DELIVERY_SCHEDULE',
    GET_VFC_POPULATION: 'GET_VFC_POPULATION',
    GET_MEDICAL_DIRECTOR: 'GET_VFC_PHYSICIAN',
    GET_LICENSED_PHYSICIAN: 'GET_VFC_PHYSICIAN',
    VFC_PHYS_TITLE: 'VFC_PHYS_TITLE',

    GET_VFC_ASSOCIATED_ADDITIONAL_OFFICE: 'GET_VFC_ASSOCIATED_ADDITIONAL_OFFICE',
    GET_VFC_VACCINE_ORDER_FREQUENCY: 'GET_VFC_VACCINE_ORDER_FREQUENCY',
    GET_VFC_VACCINE_ORDER_ALLOWANCE: 'GET_VFC_VACCINE_ORDER_ALLOWANCE',
    GET_VFC_AGREEMENT: 'GET_VFC_AGREEMENT',
    GET_VFC_BULK_ACTIVATION_STATUS: 'GET_VFC_BULK_ACTIVATION_STATUS',
  },
  USER: {
    GET_PROFILE: 'GET_PROFILE',
    GET_ACTIVE_USERS: 'GET_ACTIVE_USERS',
    SEARCH_USER: 'SEARCH_USER',
    GET_USER_PROFILE: 'GET_USER_PROFILE',
    GET_USER_TRAINING: 'GET_USER_TRAINING',
    GET_COMPONENT: 'GET_COMPONENT',
  },
  PATIENT: {
    SEARCH_PATIENT: 'SEARCH_PATIENT',
    GET_IMM_FORECAST: 'GET_IMM_FORECAST',
    GET_DOSE_GIVEN: 'GET_DOSE_GIVEN',
    GET_DOSE_REFUSAL: 'GET_DOSE_REFUSAL',
    GET_VFC_FUNDING_ELIGIBILITY: 'GET_VFC_FUNDING_ELIGIBILITY',
    GET_LOT_NUMBER: 'GET_LOT_NUMBER',
    GET_SERIES_SUMMARY: 'GET_SERIES_SUMMARY',
    GET_LEAD_TEST: 'GET_LEAD_TEST',
    GET_IMMUNITY_TEST: 'GET_IMMUNITY_TEST',
    GET_DISEASE_HISTORY: 'GET_DISEASE_HISTORY',
    GET_CONTRAINDICATIONS: 'GET_CONTRAINDICATIONS',
    GET_PATIENT_NOTE: 'GET_PATIENT_NOTE',
    GET_PATIENT_FACILITY: 'GET_PATIENT_FACILITY',
    GET_PATIENT_CONSENT: 'GET_PATIENT_CONSENT',
    GET_PATIENT_NEXT_OF_KIN: 'GET_PATIENT_NEXT_OF_KIN',
    GET_PATIENT_ALIAS: 'GET_PATIENT_ALIAS',
    GET_FOLLOWUP_SUMMARY: 'GET_FOLLOWUP_SUMMARY',
    GET_BENCHMARKS: 'GET_BENCHMARKS',
    GET_RISK_FACTOR_CODES: 'GET_RISK_FACTOR_CODES',
    GET_NBH_EBC_REPORT: 'GET_NBH_EBC_REPORT',
    GET_NBH_FOLLOWUP: 'GET_NBH_FOLLOWUP',
    GET_NBH_LOST_TO_FOLLOWUP: 'GET_NBH_LOST_TO_FOLLOWUP',
    GET_NBH_LOVS: 'GET_NBH_LOVS',
    GET_RISK_REMOVAL_REASON: 'GET_RISK_REMOVAL_REASON',
    GET_NBH_FOLLOWUP_REQUIRED_REASON: 'GET_NBH_FOLLOWUP_REQUIRED_REASON',
    GET_HIERARCHY: 'GET_HIERARCHY',
    GET_NBH_FOLLOWUP_CONTACT: 'GET_NBH_FOLLOWUP_CONTACT',
    GET_HISTORY: 'GET_HISTORY',
    SEARCH_STUDENT: 'SEARCH_STUDENT',
    GET_MERGED_PATIENT: 'GET_MERGED_PATIENT',
    GET_ADVERSE_EVENT: 'GET_ADVERSE_EVENT',
    GET_ADVERSE_EVENT_QA: 'GET_ADVERSE_EVENT_QA',
    GET_ADVERSE_EVENT_POST_VACC: 'GET_ADVERSE_EVENT_POST_VACC',
    GET_ADVERSE_EVENT_POST_MED: 'GET_ADVERSE_EVENT_POST_MED',
    GET_BULK_STUDENT_TRANSFER_STATUS: 'GET_BULK_STUDENT_TRANSFER_STATUS',
  },
  GLOBAL: {
    GET_PHONE: 'GET_PHONE',
    GET_ADDRESS: 'GET_ADDRESS',
    GET_EMAIL: 'GET_EMAIL',
    GET_NOTE: 'GET_NOTE',
    GET_CONTACT: 'GET_CONTACT'
  },
  TEMPERATURELOG: {
    GET_FACILITY_STORAGE_UNIT: 'GET_FACILITY_STORAGE_UNIT',
    GET_FACILITY_TEMPERATURE_LOG: 'GET_FACILITY_TEMPERATURE_LOG',
    GET_FACILITY_TEMPERATURE_LOG_PERIOD: 'GET_FACILITY_TEMPERATURE_LOG_PERIOD',
    GET_FACILITY_TEMPERATURE_LOG_DETAILS: 'GET_FACILITY_TEMPERATURE_LOG_DETAILS',
  },
  VACCINE_ORDERING: {
    GET_FACILITY_ORDER_HEADER: 'GET_FACILITY_ORDER_HEADER',
    GET_FACILITY_ORDER_DETAILS: 'GET_FACILITY_ORDER_DETAILS',
    AUTHORIZE_VACCINE_ORDER: 'AUTHORIZE_VACCINE_ORDER',
    GET_FACILITY_NEW_ORDER_ELIGIBLITY: 'GET_FACILITY_NEW_ORDER_ELIGIBLITY',
    GET_FACILITY_EMERGENCY_ORDER_ELIGIBLITY: 'GET_FACILITY_EMERGENCY_ORDER_ELIGIBLITY',
    GET_VFC_ORDER_RESTRICTION: 'GET_VFC_ORDER_RESTRICTION',
    GET_FACILITY_ELIGIBLE_VACCINE: 'GET_FACILITY_ELIGIBLE_VACCINE',
    GET_ORDER_ITEM_REVIEW_COUNT: 'GET_ORDER_ITEM_REVIEW_COUNT',
    GET_FACILITY_ORDER: 'GET_FACILITY_ORDER',
    GET_WASTE_EXTRACT_EVENT: 'GET_WASTE_EXTRACT_EVENT',
    GET_VACCINE_ITEMS: 'GET_VACCINE_ITEMS',
    GET_FACILITY_VACCINE_RESTRICTION: 'GET_FACILITY_VACCINE_RESTRICTION',
  },
  INTERFACE: {
    GET_FACILITY_INTERFACE_TRANSACTION: 'GET_FACILITY_INTERFACE_TRANSACTION',
    GET_FACILITY_HEDIS_TRANSACTION: 'GET_FACILITY_HEDIS_TRANSACTION',
    SEARCH_VENDOR: 'SEARCH_VENDOR',
    SEARCH_INTERFACE_ENTITY: 'SEARCH_INTERFACE_ENTITY',
    GET_FACILITIES_ASSIGNED: 'GET_FACILITIES_ASSIGNED',
    SEARCH_INTERFACE_ENROLLMENT: 'SEARCH_INTERFACE_ENROLLMENT',
    GET_INTERFACE_ENROLLMENT: 'GET_INTERFACE_ENROLLMENT',
    GET_FACILITY_EXCLUSION_LIST: 'GET_FACILITY_EXCLUSION_LIST',
    GET_INTERFACE_EXCEL_AUDIT_DATA: 'GET_INTERFACE_EXCEL_AUDIT_DATA',
  },
  AUDIT_TOOL: {
    GET_AUDIT_DATA: 'GET_AUDIT_DATA',
    GET_FACILITY_INFO: 'GET_FACILITY_INFO',
    GET_TRANSACTION_LIST: 'GET_TRANSACTION_LIST',
    GET_FACILITY_LIST: 'GET_FACILITY_LIST',
    GET_TRANSACTION_INFO: 'GET_TRANSACTION_INFO',
    GET_MESSAGE_LIST: 'GET_MESSAGE_LIST',
    GET_MESSAGE_INFO: 'GET_MESSAGE_INFO',
    GET_MESSAGE_PROFILE: 'GET_MESSAGE_PROFILE',
    GET_MESSAGE_PROFILE_DETAIL: 'GET_MESSAGE_PROFILE_DETAIL',
    GET_SUMMARY_AUDIT_REPORT_DATA: 'GET_SUMMARY_AUDIT_REPORT_DATA',
    GET_INTFC_FACILITY_TXN_STAT: 'GET_INTFC_FACILITY_TXN_STAT',
    GET_INTFC_FACILITY_TXN_MESSAGE_STAT: 'GET_INTFC_FACILITY_TXN_MESSAGE_STAT',
  },
  REMINDER_RECALL: {
    GET_REMINDER_RECALL_JOBS: 'GET_REMINDER_RECALL_JOBS',
    GET_PROCESSED_PATIENTS: 'GET_PROCESSED_PATIENTS',
    GET_BULK_TASK_STATUS: 'GET_BULK_TASK_STATUS',
  },
  REPORT: {
    GET_RECALL_VACCINE_LOT: 'GET_RECALL_VACCINE_LOT',
  },
  ADMIN: {
    GET_BULLETIN_BOARD_MESSAGES: 'GET_BULLETIN_BOARD_MESSAGES',
    GET_TRAINING_SCHEDULE: 'GET_TRAINING_SCHEDULE',
    GET_TRAINING_PRE_REGISTRATION: 'GET_TRAINING_PRE_REGISTRATION',
    GET_FAQ_MESSAGES: 'GET_FAQ_MESSAGES',
    GET_ICE_JOBS: 'GET_ICE_JOBS',
    PING_ICE_JOB: 'PING_ICE_JOB',
  },
  FORGOT_PASSWORD: {
    GET_USER_QUESTION: 'GET_USER_QUESTION',
  },
  SITE_AND_USER_ENROLLMENT: {
    GET_FACILITY_ENROLLMENT: 'GET_FACILITY_ENROLLMENT',
    GET_FACILITY_USERS: 'GET_FACILITY_USERS'
  },
  COVID19: {
    GET_COVID_VACC_ENROLL_INPROGRESS: 'GET_COVID_VACC_ENROLL_INPROGRESS',
    GET_COVID_VACC_ENROLL_ORG_IDENTIFICATION: 'GET_COVID_VACC_ENROLL_ORG_IDENTIFICATION',
    GET_COVID_VACC_ENROLL_COORDINATOR: 'GET_COVID_VACC_ENROLL_COORDINATOR',
    GET_COVID_VACC_ENROLL_OFFICE: 'GET_COVID_VACC_ENROLL_OFFICE',
    GET_COVID_VACC_ENROLL_DELIVERY_SCHEDULE: 'GET_COVID_VACC_ENROLL_DELIVERY_SCHEDULE',
    GET_COVID_VACC_ENROLL_POPULATION: 'GET_COVID_VACC_ENROLL_POPULATION',
    GET_COVID_VACC_ENROLL_STORAGE_UNIT: 'GET_COVID_VACC_ENROLL_STORAGE_UNIT',
    GET_COVID_VACC_ENROLL_LICENSED_MEDICAL_PHYSICIAN: 'GET_COVID_VACC_ENROLL_LICENSED_MEDICAL_PHYSICIAN',
    GET_COVID_VACC_ENROLL_BULK_ACTIVATION_STATUS: 'GET_COVID_VACC_ENROLL_BULK_ACTIVATION_STATUS',
    GET_LAST_COVID_VTRCKS_EXTRACT: 'GET_LAST_COVID_VTRCKS_EXTRACT',
    GET_COVID_FACILITY_DETAILS: 'GET_COVID_FACILITY_DETAILS',
    GET_MANAGE_BULK_VACCINE_UPDATE_STATUS: 'GET_MANAGE_BULK_VACCINE_UPDATE_STATUS',
    GET_KPI_FILE_INFO: 'GET_KPI_FILE_INFO',
    GET_CVRS_REPORT_FILE_STATUS: 'GET_CVRS_REPORT_FILE_STATUS',
    GET_MVRS_REPORT_FILE_STATUS: 'GET_MVRS_REPORT_FILE_STATUS',
    GET_COVID_VACC_ENROLL_THERMOMETER: 'GET_COVID_VACC_ENROLL_THERMOMETER',
  },
  STATEFUND: {
    GET_STATE_FUND_SCREEN_DATA: 'GET_STATE_FUND_SCREEN_DATA',
    GET_STATE_FUND_ENROLL_IN_PROGRESS: 'GET_STATE_FUND_ENROLL_IN_PROGRESS',
    GET_STATE_FUND_VACCINE_ORDER_FREQUENCY: 'GET_STATE_FUND_VACCINE_ORDER_FREQUENCY',
    GET_STATE_FUND_VACCINE_ORDER_PROJECTION: 'GET_STATE_FUND_VACCINE_ORDER_PROJECTION',
    GET_STATE_FUND_VACCINE_ORDER_ALLOWANCE: 'GET_STATE_FUND_VACCINE_ORDER_ALLOWANCE',
    GET_STATE_FUND_WASTE_EXTRACT_EVENT: 'GET_STATE_FUND_WASTE_EXTRACT_EVENT',
    GET_STATE_FUND_ORDER_EXTRACT_EVENT: 'GET_STATE_FUND_ORDER_EXTRACT_EVENT',
    GET_LAST_STATEFUND_VTRCKS_EXTRACT: 'GET_LAST_STATEFUND_VTRCKS_EXTRACT'
  },
  MONKEYPOX: {
    GET_PROVIDER_AGREEMENT: 'GET_PROVIDER_AGREEMENT', 
  },
  IMM48: {
    SEARCH_IMM48: 'SEARCH_IMM48',
  },
};

/**
 * Dialog messages
 */
export const DIALOG_MSGS = {
  FACILITY_INFO_UPDATE_SUCCESS: 'Facility Information updated successfully',
  CONTACT_ADD_SUCCESS: 'Contact Added Successfully',
  CONTACT_UPDATE_SUCCESS: 'Contact updated successfully',
  CONTACT_DELETE_SUCCESS: 'Contact deleted successfully',
  CONTACT_SAVED_SUCCESS: 'Contact saved successfully',
  CONFIRM_DELETE: 'Clicking on Yes will delete the record permanently. Do you want to continue?',
  ADDRESS_UPDATE_SUCCESS: 'Address updated successfully',
  INTFC_ADDED_SUCCESS: 'Interface Profile created successfully',
  INTFC_UPDATED_SUCCESS: 'Interface Profile updated successfully',
  NOTE_ADDED_SUCCESS: 'Note added successfully',
  NOTE_UPDATED_SUCCESS: 'Note updated successfully',
  RESET_WEB_SVC_ACCOUNT_KEY: 'Webservice account has been reset successfully',
  THERMOMETER_ADD_SUCCESS: 'Thermometer added successfully',
  THERMOMETER_UPDATE_SUCCESS: 'Thermometer updated successfully',
  THERMOMETER_DELETE_SUCCESS: 'Thermometer deleted successfully',
  THERMOMETER_FILE_UPLOAD_SUCCESS: 'Thermometer certification uploaded successfully',
  LICENSE_MEDICAL_PHYSICIAN_ADD_SUCCESS: 'Licensed Medical Physician added successfully',
  LICENSE_MEDICAL_PHYSICIAN_UPDATE_SUCCESS: 'Licensed Medical Physician updated successfully',
  LICENSE_MEDICAL_PHYSICIAN_DELETE_SUCCESS: 'Licensed Medical Physician deleted successfully',
  ASSOCIATED_MEDICAL_OFFICE_ADD_SUCCESS: 'Associated Medical Office added successfully',
  ASSOCIATED_MEDICAL_OFFICE_UPDATE_SUCCESS: 'Associated Medical Office updated successfully',
  ASSOCIATED_MEDICAL_OFFICE_DELETE_SUCCESS: 'Associated Medical Office deleted successfully',
  APPROVE_VFC_MSG: 'Site enrollment for this year is approved successfully',
  REJECT_VFC_MSG: 'Site enrollment for this year is rejected',
  SUBMIT_VFC_MSG: 'Your site enrollment for this year is submitted successfully',
  SYSTEM_CREATE_SUCCESS: 'System created successfully',
  SYSTEM_UPDATE_SUCCESS: 'System updated successfully',
  GROUP_CREATE_SUCCESS: 'Group created successfully',
  GROUP_UPDATE_SUCCESS: 'Group updated successfully',
  SEND_EMAIL_NO_EMAIL: 'No Email addresses available',
  SEND_MAIL_SUCCESS: 'Email was sent successfully',
  PATIENT_CREATED_SUCCESS: 'Patient created successfully with RegistryId - ',
  UPDATE_PATIENT_CRITICAL_INFORMATION_SUCCESS: 'Patient critical information updated successfully',
  UPDATE_PATIENT_INSURANCE_INFORMATION_SUCCESS: 'Patient insurance information updated successfully',
  ADD_DOSE_SUCCESS: 'New Immunization dose added successfully',
  DELETE_DOSE_SUCCESS: 'Dose deleted successfully',
  ASSIGN_MEDICAL_FACILITY: 'Do you really want to Assign Medical Facility ?',
  UPDATE_DOSE_SUCCESS: 'Immunization dose Updated successfully',
  DELETE_AND_ADD_DOSE_SUCCESS: 'Deleted and Added dose successfully',
  REVACC_DOSE_SUCCESS: 'Dose revaccinated successfully',
  HISTORY_DOSE_SUCCESS: 'History dose added successfully',
  ADD_REFUSAL_SUCCESS: 'Refusal added successfully',
  UPDATE_REFUSAL_SUCCESS: 'Refusal updated successfully',
  DELETE_REFUSAL_SUCCESS: 'Refusal deleted successfully',
  ADD_LEAD_TEST_SUCCESS: 'Lead Test added successfully',
  UPDATE_LEAD_TEST_SUCCESS: 'Lead Test updated successfully',
  DELETE_LEAD_TEST_SUCCESS: 'Lead Test deleted successfully',
  ADD_IMMUNITY_TEST_SUCCESS: 'Immunity Test added successfully',
  UPDATE_IMMUNITY_TEST_SUCCESS: 'Immunity Test updated successfully',
  DELETE_IMMUNITY_TEST_SUCCESS: 'Immunity Test deleted successfully',
  ADD_DISEASE_HISTORY_SUCCESS: 'Disease History added successfully',
  UPDATE_DISEASE_HISTORY_SUCCESS: 'Disease History updated successfully',
  DELETE_DISEASE_HISTORY_SUCCESS: 'Disease History deleted successfully',
  ADD_CONTRAINDICATIONS_SUCCESS: 'Contraindications added successfully',
  UPDATE_CONTRAINDICATIONS_SUCCESS: 'Contraindications updated successfully',
  DELETE_CONTRAINDICATIONS_SUCCESS: 'Contraindications deleted successfully',
  ADD_PATIENT_NOTE_SUCCESS: 'Patient Note added successfully',
  UPDATE_PATIENT_NOTE_SUCCESS: 'Patient Note updated successfully',
  DELETE_PATIENT_NOTE_SUCCESS: 'Patient Note deleted successfully',
  UPDATE_PATIENT_MEDICAL_FAC_SUCCESS: 'Medical Facility updated successfully',
  UPDATE_PATIENT_PERSONAL_INFO_SUCCESS: 'Patient Personal Information updated successfully',
  UPDATE_PATIENT_CONSENT_INFORMATION: 'Patient Consent Information updated successfully',
  OUTREACH_FLAG_SELECT_MESSAGE:
    'Another Address is already flagged as Outreach Address for this Patient. Do you want to make this one Outreach Address?',
  OUTREACH_FLAG_CLEAR_MESSAGE: 'Please select another address as Outreach address',
  PATIENT_ADDRESS_FLAG_SELECT_MESSAGE:
    'Another Address is already flagged as Patient Address for this Patient. Do you want to make this one Patient Address?',
  PATIENT_ADDRESS_FLAG_CLEAR_MESSAGE: 'Please select another address as Patient Address',
  UPDATE_PATIENT_ADDRESS_SUCCESS: 'Patient Address information updated successfully',
  DELETE_PATIENT_ADDRESS_SUCCESS: 'Patient Address information deleted successfully',
  UPDATE_PATIENT_CONTACT_SUCCESS: 'Patient Contact information updated successfully',
  DELETE_PATIENT_CONTACT_SUCCESS: 'Patient Contact information deleted successfully',
  DELETE_PATIENT_RELATIVE_SUCCESS: 'Patient relative information deleted successfully',
  DELETE_PATIENT_RELATIVE_ADDRESS_SUCCESS: 'Patient relative address information deleted successfully',
  RELATIVE_OUTREACH_CANNOT_DELETE:
    'Address marked as Outreach Address cannot be deleted. Please create or select another address as Outreach Address before deleting.',
  RELATIVE_PATIENT_ADDRESS_CANNOT_DELETE:
    'Address marked as Patient Address cannot be deleted. Please create or select another address as Patient Address before deleting.',
  PATIENT_ADD_ADDRESS_SUCCESS: 'Address added successfully for patient',
  PATIENT_ADD_RELATIVE_SUCCESS: 'Relative added successfully for patient',
  ATLEAST_ONE_ADDRESS_PRESENT: 'Address cannot be deleted, at least one address should be present',
  DELETE_ADDRESS_AND_RELATIVE:
    'At least one address should be present for the relative, deleting this address will delete the relative. Are you sure want to delete this relative?',
  UPDATE_CONFIDENTIAL_INFORMATION_SUCCESS: 'Confidential information updated successfully',
  ADD_PATIENT_ALIAS_SUCCESS: 'Patient Alias added successfully',
  UPDATE_PATIENT_ALIAS_SUCCESS: 'Patient Alias updated successfully',
  DELETE_PATIENT_ALIAS_SUCCESS: 'Patient Alias deleted successfully',
  UPDATE_SCHOOL_SUCCESS: 'Patient school information updated successfully',
  DELETE_SCHOOL_ALERT: 'Patient has no School information. Cannot UnAssign School for the patient',
  CONFIRM_UNASSIGN_SCHOOL: 'Are you sure you want to UnAssign the School for the Patient?',
  DELETE_SCHOOL_SUCCESS: 'Patient school information unassigned successfully',
  ADD_FOLLOWUP_SUCCESS: 'Patient Followup added successfully',
  UPDATE_FOLLOWUP_SUCCESS: 'Patient Followup updated successfully',
  DELETE_FOLLOWUP_SUCCESS: 'Patient Followup deleted successfully',
  EHDI_AGE_GT3_CONFIRM:
    'EHDI rules only require documentation on the EHDI forms for children under age 3.  This record is for a person over age 3.  Are you sure you want to continue?',
  UPDATE_NBH_RISK_FACTOR_CODES: 'Risk Factor codes updated successfully',
  ADD_LOSTTO_FOLLOWUP_SUCCESS: 'Lost to Followup report added successfully',
  UPDATE_LOSTTO_FOLLOWUP_SUCCESS: 'Lost to Followup report updated successfully',
  DELETE_LOSTTO_FOLLOWUP_SUCCESS: 'Lost to Followup report deleted successfully',
  ADD_FOLLOWUP_CONTACT_SUCCESS: 'Followup contact added successfully',
  UPDATE_FOLLOWUP_CONTACT_SUCCESS: 'Followup contact updated successfully',
  DELETE_FOLLOWUP_CONTACT_SUCCESS: 'Followup contact deleted successfully',
  CHANGE_FACILITY_CONFIRM:
    'Changing the Facility might change your navigation links based on the access level for that facility. Still do you want to continue ?',
  ADD_NBH_FOLLOWUP_SUCCESS: 'Followup report added successfully',
  UPDATE_NBH_FOLLOWUP_SUCCESS: 'Followup report updated successfully',
  DELETE_NBH_FOLLOWUP_SUCCESS: 'Followup report deleted successfully',
  MERGE_PATIENT_SUCCESS: 'Merging Patients completed successfully',
  UNMERGE_PATIENT_SUCCESS: 'Unmerging Patients completed successfully',
  CHANGE_STATUS_SUCCESS: 'Patient status updated successfully',
  ASSIGN_PROFILE_ERROR: 'Please select a Profile',
  PROFILE_ALL_FACILITY_ERROR:
    'You already have a profile that is assigned with All Facilities, please unassign the profile and then select desired profile',
  WARN_USER_ALL_FAC_SELECTION: 'By selecting this option all the facilities will be assigned to this user',
  ASSIGN_FACILITY_ERROR: 'Please select a Facility',
  NO_FACILITY_MSG: 'No Facility available for the select search criteria',
  UNASSIGN_PROFILE_SUCCESS: 'Profile unassigned successfully',
  CLONE_USER_SUCCESS: 'User cloned successfully',
  PROFILE_MORE_FUNCTIONS_AND_REPORT_ADDED_ERROR: 'Please limit the combination of additional Function and Report(s) to 4',
  ADD_PROFILE_SUCCESS: 'User profile added successfully',
  UPDATE_PROFILE_SUCCESS: 'User profile updated successfully',
  UPDATE_USER_SUCCESS: 'User updated successfully',
  RESET_PASSWORD_SUCCESS: 'Password reset successfully',
  RESET_PASSWORD_EMAIL_ERROR: 'Please update user email address to perform password reset',
  CLAIM_SHIPMENT_SUCCESS: 'Requested order(s) claimed successfully',
  ADD_STORAGE_UNIT: 'Storage Unit saved successfully',
  UPDATE_STORAGE_UNIT: 'Storage Unit updated successfully',
  DELETE_STORAGE_UNIT: 'Storage Unit deleted successfully',
  CONFIRM_TEMP_LOG_DEACTIVATION:
    'By deactivating the unit you will not be able to enter temperature log for the next month.<br/> Clicking on Yes will deactivate the unit- do you want to continue?',
  CONFIRM_DELETE_STORAGE_UNIT: 'Clicking on Yes will delete the storage unit permanently - do you want to continue?',
  SAVE_TEMP_LOG_SUCCESS: 'Temperature Log Saved Successfully',
  SUBMIT_TEMP_LOG_SUCCESS: 'Temperature Log Submitted Successfully',
  DELETE_TEMP_LOG_SUCCESS: 'Temperature Log Deleted Successfully',
  ACTIVATE_USER_SUCCESS: 'User activated successfully. You will be taken to login screen, please login with your credentials.',
  NO_TEMP_LOGS_AVAILABLE: 'No Temperature Log available for this unit',
  CHANGE_PASSWORD_SUCCESS: 'Password has been updated successfully. Please login again with new password.',
  ORDERING_MORE_THAN_RESTRICTED_QTY: 'You are ordering more than the restricted quantity. Please authorize the order.',
  AUTHORIZE_ERROR: 'Please enter a valid Authorizing UserID and Authorization PIN',
  UPDATE_VACCINE_ORDER_SUCCESS: 'Order updated successfully',
  CANCEL_VACCINE_ORDER: 'Clicking on Yes will cancel the order - do you want to continue?',
  CANCEL_VACCINE_ORDER_SUCCESS: 'Order cancelled successfully',
  OPEN_ORDER_VALIDATION_ERROR: 'Please select at least one In Review Orders to Open',
  OPEN_ORDER_SUCCESS: 'Order status updated successfully',
  PLACE_ORDER_ADMIN_CONFIRM: 'Please verify your shipping address and delivery instructions before placing the order',
  RUN_WASTE_EXTRACT_SUCCESS: 'Extract ran successfully, results will be refreshed',
  CLAIM_SINGLE_FORM_SUCESS: 'Successfully claimed the form selected for VFC enrollment',
  CLAIM_SINGLE_FORM_SUCESS_FOR_REENROLL: 'Successfully claimed the form selected for VFC re-enrollment',
  VFC_COMMENTS_SAVED_SUCCESS: 'Comments saved successfully',
  VFC_APPROVE_ERROR: 'Unable to approve the form. Please correct the form for error(s) before approving.',
  VFC_ACTIVATE_ERROR: 'Unable to activate the form. Please correct the form for error(s) before activating.',
  CLAIM_REENROLLMENT_FORMS_SUCESS: 'Successfully claimed the forms selected for VFC re-enrollment(s)',
  UPDATE_ORDER_RESTRICTION_SUCCESS: 'Days between orders updated successfully',
  CONFIRM_DELETE_VACC_RESTRICTION: 'Clicking on Yes will delete all the Vaccine Restrictions permanently - do you want to continue?',
  UPDATE_VACC_RESTRICTION_SUCCESS: 'Vaccine Restrictions updated successfully',
  DELETE_VACC_RESTRICTION_SUCCESS: 'Vaccine Restrictions deleted successfully',
  CONFIRM_VACCINE_REMOVE: 'This vaccine will be removed permanently from the vaccine list, do you want to continue?',
  UPDATE_VACCINE_LIST_SUCCESS: 'Vaccine List updated successfully',
  UPDATE_VFC_VACCINE_MAP_SUCCESS: 'Facility Type setup saved successfully',
  UPLOAD_HEDIS_FILE_SUCCESS: 'File has been uploaded successfully',
  VENDOR_CREATE_SUCCESS: 'Vendor created successfully',
  VENDOR_UPDATE_SUCCESS: 'Vendor updated successfully',
  CREATE_ENTITY_SUCCESS: 'Interface Entity created successfully',
  UPDATE_ENTITY_SUCCESS: 'Interface Entity updated successfully',
  UPDATE_INTERFACE_ENROLLMENT_SUCCESS: 'Successfully updated the Interface Enrollment Form',
  CREATE_INTERFACE_ENROLLMENT_SUCCESS: 'Successfully updated the Interface Enrollment Form',
  ADD_RR_SUCCESS: 'Reminder Recall job added successfully',
  CONFIRM_DELETE_RR_JOB: 'Are you sure you want to delete the selected Job',
  DELETE_RR_SUCCESS: 'Reminder Recall Report deleted successfully',
  UNCLAIM_PATIENTS_SUCCESS: 'Selected patient(s) were UnClaimed successfully',
  CLAIM_PATIENTS_SUCCESS: 'Selected patient(s) were Claimed successfully',
  FOLLOWUP_PATIENTS_SUCCESS: 'FollowUp created for selected patient(s) successfully',
  FILE_UPLOAD_SUCCESS: 'File uploaded successfully',
  ADD_BULLETIN_BOARD_MSG_SUCCESS: 'Bulletin Board message added successfully',
  UPDATE_BULLETIN_BOARD_MSG_SUCCESS: 'Bulletin Board message updated successfully',
  ADD_FAQ_MSG_SUCCESS: 'Message added successfully',
  UPDATE_FAQ_MSG_SUCCESS: 'Message updated successfully',
  ADD_TRAINING_SCHEDULE_MSG_SUCCESS: 'Training Schedule added successfully',
  UPDATE_TRAINING_SCHEDULE_MSG_SUCCESS: 'Training Schedule updated successfully',
  CONFIRM_DELETE_TRAINING_SCHEDULE: 'Clicking on Yes will delete the Training Schedule permanently - do you want to continue?',
  DELETE_TRAINING_SCHEDULE_SUCCESS: 'Training Schedule deleted successfully',
  UPDATE_TRAINING_PRE_REGISTRATION_SUCCESS: 'Training Pre-Registration updated successfully',
  CREATE_ICE_JOB_SUCCESS: 'Ice Job created successfully',
  PROCESSED_ICE_JOB_SUCCESS: 'ICE Job has been processed successfully',
  UPDATE_SECURITY_QUESTION_SUCCESS: 'User Security Questions updated successfully',
  UNABLE_TO_VERIFY_USER: 'Unable to verify user',
  ACTIVATE_WEBSVC_SUCCESS: 'Web Service Account Key activated successfully',
  UPDATE_FACILITY_ENROLLMENT: 'New Site Enrollment form updated successfully',
  UPDATE_USER_ENROLLMENT: 'User Enrollment form updated successfully',
  UPDATE_USER_AGREEMENT_SUCCESS: 'User Agreement saved successfully',
  COVID_VACCINE_ENROLLMENT_CLAIM_SINGLE_FORM_SUCESS: 'Successfully claimed the form selected for COVID-19 Vaccine enrollment',
  APPROVE_COVID_VACCINE_ENROLLMENT_MSG: 'COVID-19 Vaccine Enrollment for this year is approved successfully',
  REJECT_COVID_VACCINE_ENROLLMENT_MSG: 'COVID-19 Vaccine Enrollment for this year is rejected',
  SUBMIT_COVID_VACCINE_ENROLLMENT_MSG: 'Your COVID-19 Vaccine Enrollment for this year is submitted successfully',
  STATUS_CHANGE_COVID_VACCINE_ENROLLMENT_MSG: 'COVID-19 Vaccine Enrollment updated successfully',
  STATE_FUND_ENROLLMENT_CLAIM_SINGLE_FORM_SUCESS: 'Successfully claimed the form selected for State Fund Vaccine enrollment',
  APPROVE_STATE_FUND_ENROLLMENT_MSG: 'State Fund Vaccine Enrollment is approved successfully',
  ACTIVATE_STATE_FUND_ENROLLMENT_MSG: 'State Fund Vaccine Enrollment is activated successfully',
  REJECT_STATE_FUND_ENROLLMENT_MSG: 'State Fund Vaccine Enrollment is rejected',
  SUBMIT_STATE_FUND_ENROLLMENT_MSG: 'Your State Fund Vaccine Enrollment is submitted successfully',
  STATUS_CHANGE_STATE_FUND_ENROLLMENT_MSG: 'State Fund Vaccine Enrollment updated successfully',
  ADD_ADVERSE_EVENT_SUCCESS: 'Adverse Event added successfully',
  UPDATE_ADVERSE_EVENT_SUCCESS: 'Adverse Event updated successfully',
  DELETE_ADVERSE_EVENT_SUCCESS: 'Adverse Event deleted successfully',
  IMM48_CLAIM_SUCCESS: 'Successfully claimed the IMM-48 form',
  IMM48_APPROVE_SUCCESS: 'IMM-48 form is approved successfully',
  IMM48_REJECT_SUCCESS: 'IMM-48 form is rejected successfully',
  ACTIVATE_ENROLLMENT_SUCCESS : 'Enrollment Activated successfully',
  SCHOOL_FORM_UPDATED_SUCCESS : 'School Form updated successfully'
};

/**
 * LOV Properties constants
 */
export const LOV_PROPERTIES = {
  DESCRIPTION: 'descr',
  DISPLAY_ORDER: 'displayOrder',
};

/**
 * Table sort order
 */
export const TABLE_SORT_ORDER = {
  ASC: 1,
  DESC: -1,
};

/**
 * Modes of VFC
 */
export const VFC_MODES = {
  VFC_ADMIN_EDIT: 'VFC_ADMIN_EDIT',
  VFC_RE_ENROLL: 'VFC_RE_ENROLL',
  VFC_ENROLL_ADMIN: 'VFC_ENROLL_ADMIN',
  VFC_ENROLL : "VFC_ENROLL"

};

/**
 * VFC Re-Enrollment mode constants
 */
export const VFC_REENROLLMENT_MODE = {
  REENROLLMENT: 'REENROLLMENT',
  RENROLLMGMT: 'RENROLLMGMT',
};

export const VFC_ENROLLMENT_MODE = {
  ENROLLMENT: 'ENROLLMENT',
  ENROLLMGMT: 'ENROLLMGMT',
};


/**
 * VFC menus
 */
export const VFC_MENU = {
  VFC_MENU_ADMIN_EDIT: 'VFC_MENU_ADMIN_EDIT',
  VFC_MENU_ENROLL_ADMIN: 'VFC_MENU_ENROLL_ADMIN',
  VFC_MENU_RE_ENROLL: 'VFC_MENU_RE_ENROLL',
  VFC_MENU_ENROLL : 'VFC_MENU_ENROLL'
};

/**
 * List of VFC Tabs column values
 */
export const VFC_MENU_COLUMN_VALUES = {
  INFORMATION: 'INFORMATION',
  VFC_FACILITY_TYPE: 'VFC_FACILITY_TYPE',
  ORG_IDENTIFICATION: 'ORG_IDENTIFICATION',
  VACC_OFFERED: 'VACC_OFFERED',
  VACC_COORDINATOR: 'VACC_COORDINATOR',
  THERMOMETER: 'THERMOMETER',
  FACILITY_STORAGE: 'FACILITY_STORAGE',
  OFFICE_INFO: 'OFFICE_INFO',
  VACCINE_DELIVERY: 'VACC_DELIVERY',
  POPULATION: 'POPULATION',
  MEDICAL_DIRECTOR: 'MEDICAL_DIRECTOR',
  PHYSICIAN: 'PHYSICIAN',
  ASSOCIATED_OFFICE: 'ASSOCIATED_OFFICE',
  REVIEW: 'REVIEW',
  ORDERING_FREQUENCY: 'ORDERING_FREQUENCY',
  VACCINE_ALLOWANCE: 'VACCINE_ALLOWANCE',
  VFC_MANAGEMENT: 'VFC_MANAGEMENT',
  AGREEMENT: 'AGREEMENT',
};

/**
 * List of request key for each of the tab in VFC
 */
export const VFC_MENU_TAB_REQUEST_KEY = {
  VFC_FACILITY_TYPE: 'facilityType',
  VACC_OFFERED: 'vaccineOffered',
  VACC_COORDINATOR: 'vaccineCoordinator',
  THERMOMETER: 'thermometer',
  FACILITY_STORAGE: 'facilityStorageList',
  OFFICE_INFO: 'office',
  VACCINE_DELIVERY: 'deliverySchedule',
  POPULATION: 'facilityPopulation',
  MEDICAL_DIRECTOR: 'physician',
  PHYSICIAN: 'physician',
  ASSOCIATED_OFFICE: 'associatedOffice',
  REVIEW: 'REVIEW',
  ORDERING_FREQUENCY: 'orderFrequency',
  VACCINE_ALLOWANCE: 'vaccineAllowanceList',
  VFC_MANAGEMENT: 'VFC_MANAGEMENT',
  AGREEMENT: 'agreement',
};

/**
 * FACILITY ENROLLMENT MENU
 */
export const FACILITY_ENROLL_MENU_VALUES = {
  NEW_FACILITY: 'NEW FACILITY',
  NEW_USER: 'NEW USER',
  ACKDGE: 'ACKNOWLEDGEMENT',
  REVIEW: 'REVIEW'
}

/**
 * Contact Type constants
 */
export const CONTACT_TYPE = {
  PRIMARY: '2',
  BACKUP: '11',
  COVID_PRIMARY: '16',
  COVID_BACKUP: '17',
  SF_PRIMARY: '20',
  SF_BACKUP: '21',
};

/**
 * Physician Type constants
 */
export const PHYSICIAN_TYPE = {
  MEDICAL_DIRECTOR: '1',
  LICENSED_MEDICAL_PHYSICIAN: '2',
};

/**
 * Table cell width constants
 */
export const TABLE_CELL_WIDTH = {
  SMALL: 'table-small-cell-width', // 8%
  SMALLER: 'table-xsmall-cell-width', // 5%
  SMALLEST: 'table-verysmall-cell-width', // 2%
  ACTION: 'table-action-width', // 2%
  DATE_CELL: 'table-date-cell-width', // 2.45%
  MEDIUM1: 'table-medium1-cell-width', // 12%
  MEDIUM: 'table-medium-cell-width', // 20%
  LARGE: 'table-large-cell-width', // 40%
  LARGEST: 'table-xlarge-cell-width', // 60%
};

/**
 * Sort Type constants
 */
export const SORT_TYPE = {
  DATE: 'date',
  NUMBER: 'number',
};

/**
 * VFC Status constants
 */
export const VFC_STATUS = {
  IN_PROGRESS: '0',
  SUBMITTED: '1',
  INREVIEW: '2',
  APPROVE: '3',
  REJECT: '4',
  ACTIVATE: '5',
  HOLD: '6',
  PHASE_I_ENROLLMENT: '7',
  PHASE_II_ENROLLMENT: '8',
};

/**
 * Send Email Category constants
 */
export const SEND_EMAIL_CATEGORY = {
  /**
   * County Fac Type columnValue
   */
  COUNTY_FAC_TYPE: '1',

  /**
   * Municipality columnValue
   */
  MUNICIPALITY: '2',

  /**
   * Facility subType columnValue
   */
  FAC_SUBTYPE: '3',

  /**
   * County and VFC Ordering Frequency columnValue
   */
  COUNTY_VFC_ORD_FREQ: '4',

  /**
   * VFC Fac Type and Ordering Frequency columnValue
   */
  VFC_FAC_TYPE_ORD_FREQ: '5',

  /**
   * County user columnValue
   */
  COUNTY_USER: '6',

  /**
   * user profile columnValue
   */
  PRFL_USER: '7',
};

/**
 * Busy Message constants
 */
export const BUSY_MESSAGE = {
  FORECASTING: 'Retrieving Forecasting Details',
  PLEASE_WAIT: 'Please wait',
  ACQUIRE_LOCKS: 'Acquiring Locks',
  RELEASE_LOCKS: 'Release Locks',
  ADD_DOSE: 'Adding Dose',
  DELETE_DOSE: 'Deleting Dose',
  UPDATE_DOSE: 'Updating Dose',
  DELETE_AND_ADD_DOSE: 'Deleting and Adding Dose',
  REVACCINATE_DOSE: 'Revaccinating Dose',
  HISTORY_DOSE: 'Adding History Dose',
  GET_REFUSAL: 'Retrieving Refusals',
  GET_DOSE: 'Retrieving Doses',
  ADD_REFUSAL: 'Adding Refusal',
  UPDATE_REFUSAL: 'Updating Refusal',
  DELETE_REFUSAL: 'Deleting Refusal',
  GET_SERIES_SUMMARY: 'Retrieving Series Summary',
  GET_LEAD_TEST: 'Retrieving Lead Test',
  ADD_LEAD_TEST: 'Adding Lead Test',
  UPDATE_LEAD_TEST: 'Updating Lead Test',
  DELETE_LEAD_TEST: 'Deleting Lead Test',
  GET_IMMUNITY_TEST: 'Retrieving Immunity Test',
  ADD_IMMUNITY_TEST: 'Adding Immunity Test',
  UPDATE_IMMUNITY_TEST: 'Updating Immunity Test',
  DELETE_IMMUNITY_TEST: 'Deleting Immunity Test',
  GET_DISEASE_HISTORY: 'Retrieve Disease History results',
  ADD_DISEASE_HISTORY: 'Adding Disease History',
  UPDATE_DISEASE_HISTORY: 'Updating Disease History',
  DELETE_DISEASE_HISTORY: 'Deleting Disease History',
  GET_CONTRAINDICATIONS: 'Retrieve Contraindications results',
  ADD_CONTRAINDICATIONS: 'Adding Disease History',
  UPDATE_CONTRAINDICATIONS: 'Updating Contraindications',
  DELETE_CONTRAINDICATIONS: 'Deleting Contraindications',
  ADD_PATIENT_NOTE: 'Adding Patient Note',
  UPDATE_PATIENT_NOTE: 'Updating Patient Note',
  DELETE_PATIENT_NOTE: 'Deleting Patient Note',
  UPDATE_MEDICAL_FACILITY: 'Updating Medical Facility for Patient',
  UPDATE_PATIENT_PERSONAL_INFO: 'Updating Patient Personal Information',
  GET_CONSENT_HISTORY: 'Retrieving Patient Consent History',
  UPDATE_CONSENT_INFORMATION: 'Updating Consent Information',
  UPDATE_PATIENT_ADDRESS: 'Updating Address Information',
  UPDATE_PATIENT_CONTACT: 'Updating Contact Information',
  DELETE_PATIENT_RELATIVE: 'Deleting Relative Information',
  DELETE_PATIENT_RELATIVE_ADDRESS: 'Deleting Relative Address Information',
  ADDING_ADDRESS: 'Adding Address for relative',
  ADDING_RELATIVE: 'Adding Relative for patient',
  UPDATE_CONFIDENTIAL_INFORMATION: 'Updating Confidential Information',
  GET_PATIENT_ALIAS: 'Retrieving Patient Aliase(s)',
  ADD_PATIENT_ALIAS: 'Adding Patient Alias',
  UPDATE_PATIENT_ALIAS: 'Updating Patient Alias',
  DELETE_PATIENT_ALIAS: 'Deleting Patient Alias',
  GET_SCHOOL: 'Retrieving School List',
  UPDATE_SCHOOL: 'Updating School information',
  UNASSIGN_SCHOOL: 'Unassigning School for the patient',
  GET_FOLLOW_UP: 'Retrieving followup for the patient',
  ADD_FOLLOW_UP: 'Adding Followup for the patient',
  UPDATE_FOLLOW_UP: 'Updating Followup for the patient',
  DELETE_FOLLOW_UP: 'Deleting Followup for the patient',
  UPDATE_RISK_FACTOR_CODES: 'Updating Risk Factor Codes',
  GET_NBH_FOLLOWUP_REQUIRED_REASON: 'Retrieving NBH Followup Required Reason',
  ADD_LOSTTO_FOLLOWUP: 'Adding Lost to Followup report',
  UPDATE_LOSTTO_FOLLOWUP: 'Updating Lost to Followup report',
  DELETE_LOSTTO_FOLLOWUP: 'Deleting Lost to Followup report',
  GET_LOSTTOFOLLOWUP_DETAILS: 'Retrieving Lost to Followup Details',
  GET_NBH_FOLLOWUP_CONTACT: 'Retrieving Followup Contact Logs',
  ADD_FOLLOWUP_CONTACT: 'Adding Followup contact report',
  UPDATE_FOLLOWUP_CONTACT: 'Updating Followup contact report',
  DELETE_FOLLOWUP_CONTACT: 'Deleting Followup contact report',
  GET_AUDIOLOGICAL_FACILITY: 'Retrieving Audiological Facility List',
  ADD_NBH_FOLLOWUP: 'Adding Followup report',
  UPDATE_NBH_FOLLOWUP: 'Updating Followup report',
  DELETE_NBH_FOLLOWUP: 'Deleting Followup report',
  GET_NBH_FOLLOWUP_DETAILS: 'Retrieving Followup report Details',
  GET_HISTORY: 'Retrieving Patient History',
  SEARCH_STUDENT: 'Retrieving Student(s)',
  SEARCH_PATIENT: 'Retrieving Patient(s)',
  MERGE_PATIENT: 'Merging Patients',
  GET_MERGED_PATIENT: 'Retrieving Merged patients',
  UNMERGE_PATIENTS: 'Unmerging Patients',
  CHANGE_STATUS: 'Updating status of the patient',
  GET_ACTIVE_USERS: 'Retrieving Active users',
  SEARCH_USER: 'Searching Users',
  CREATE_USER: 'Creating User',
  GET_USER_DETAILS: 'Retrieving User Details',
  GET_PROFILES: 'Retrieving Profiles',
  GET_LOVS: 'Retrieving Lovs',
  SEARCH_FACILITIES: 'Searching Facilities',
  GET_COMPONENTS: 'Retrieving modules and reports',
  CLONE_USER: 'Cloning User',
  UNASSIGN_USER_PROFILE: 'Unassigning User Profile',
  ADD_USER_PROFILE: 'Adding User Profile',
  UPDATE_USER_PROFILE: 'Updating User Profile',
  UPDATE_USER: 'Updating user',
  RESET_USER_PASSWORD: 'Resetting User password',
  UPDATE_PROFILE: 'Updating Profile',
  ADD_PROFILE: 'Adding Profile',
  DELETE_PROFILE: 'Deleting Profile',
  RETRIEVING_SHIPMENT: 'Retrieving Shipment Details',
  CLAIM_SHIPMENT: 'Claiming Shipment',
  ADD_STORAGE_UNIT: 'Adding Storage Unit',
  UPDATE_STORAGE_UNIT: 'Updating Storage Unit',
  DELETE_STORAGE_UNIT: 'Deleting Storage Unit',
  SAVE_TEMP_LOG: 'Saving Temperature Log',
  SUBMIT_TEMP_LOG: 'Submitting Temperature Log',
  DELETE_TEMP_LOG: 'Deleting Temperature Log',
  CHECK_ACTIVATION_KEY: 'Validating Activation Key',
  ACTIVATE_USER: 'Activating User',
  GET_ORDER_HEADER: 'Retreiving Facility Details',
  UPDATING_VACCINE_ORDER: 'Updating Order',
  CANCEL_VACCINE_ORDER: 'Cancelling Order',
  OPEN_VACCINE_ORDER: 'Updating Order(s) to OPEN',
  GET_PLACE_ORDER_VACCINE_LIST: 'Retrieving Vaccine List',
  PLACE_VACCINE_ORDER: 'Placing Vaccine Order(s)',
  GET_WASTE_EXTRACT: 'Retreiving waste extract',
  RUN_WASTE_EXTRACT: 'Running Waste Extract',
  DOWNLOAD_WASTE_EXTRACT: 'Downloading Waste Extract',
  GET_REENROLLMENT_LIST: 'Searching for Reenrollment Forms',
  GET_ENROLLMENT_LIST : "Searching for Enrollment Forms",
  CLAIM_REENROLLMENT_FORMS: 'Claiming Reenrollment Form(s)',
  BULK_ACTIVATE_VFC_FORMS: 'Activating VFC Form(s)',
  BULK_VFC_ACTIVATION_INPROGRESS: 'VFC Activation for selected form(s) is in progress...',
  GET_VFC_ORDER_RESTRICTION: 'Retreiving Order restriction',
  UPDATE_ORDER_RESTRICTION: 'Updating Order Restriction',
  UPDATE_VACCINE_RESTRICTION: 'Updating Vaccine Restrictions',
  DELETE_VACCINE_RESTRICTION: 'Deleting Vaccine Restrictions',
  GET_VACCINE_LIST: 'Retrieving Vaccines',
  UPDATE_VACCINE_LIST: 'Updating Vaccine',
  UPDATE_VFC_VACCINE_MAP: 'Updating VFC Vaccine Brand mapping',
  GET_FACILITY_INTERFACE_TRANSACTION: 'Retreiving Facility Interface Transaction details',
  UPLOADING_INTFC_FILE: 'Uploading file',
  DOWNLOAD_FILE: 'Downloading file',
  GET_HEDIS_TRANSACTION_LIST: 'Retrieving HEDIS transaction list',
  UPLOAD_HEDIS_FILE: 'Uploading HEDIS file',
  DOWNLOAD_HEDIS_FILE: 'Downloading HEDIS file',
  GET_VENDOR: 'Retrieving Vendor(s)',
  GET_VENDOR_DETAILS: 'Retrieving Vendor Details',
  GET_ENTITY_LIST: 'Retrieving Entity List',
  GET_FACILITIES_ASSIGNED: 'Retrieving Facilities Assigned',
  GET_INTERFACE_FORMS: 'Retrieving Interface Form(s)',
  GET_ENROLLMENT_DETAILS: 'Retrieving Enrollment Details',
  UPDATE_INTERFACE_ENROLLMENT: 'Updating Interface Enrollment form',
  CREATE_INTERFACE_ENROLLMENT: 'Creating Interface Enrollment form',
  GET_FACILITY_CONTACT: 'Retrieving Facility Contact information',
  GET_TRANSACTION_LIST: 'Retrieving Transaction List',
  GET_TRANSACTION_INFO: 'Retrieving Transaction Details',
  GET_MESSAGES_LIST: 'Retrieving Message List',
  GET_MESSAGE_INFO: 'Retrieving Message Info',
  GET_MESSAGE_PROFILE_LIST: 'Retrieving Message Profile List',
  GET_AUDIT_FACILITIES_LIST: 'Checking for Facilities',
  GET_MESSAGE_DETAIL_PROFILE: 'Retrieving Message Detail Profile list',
  GET_SUMMARY_AUDIT_DATA_REPORT: 'Retrieving Summary Audit Report list',
  GET_INTFC_FACILITY_TXN_STAT: 'Retrieving Transaction statistics for Facility',
  SEND_EMAIL: 'Sending Email',
  GET_INTFC_FACILITY_MSG_STAT: 'Retrieving Message statistics for Transaction Id',
  GET_REMINDER_RECALL_JOBS: 'Retrieving Reminder Recall jobs',
  ADD_RR_JOB: 'Adding Reminder Recall Job',
  DELETE_RR_JOB: 'Deleting Reminder Recall Job',
  GET_PROCESSED_PATIENTS: 'Retrieving List of Patients',
  ASSIGN_PATIENTS: 'Claiming selected Patient(s)',
  UNASSIGN_PATIENTS: 'Unclaiming selected Patient(s)',
  CREATE_FOLLOWUP: 'Createing Followup for the Patient(s)',
  GET_LOT_NUMER: 'Retrieving Lot Number list',
  GET_BULLETIN_BOARD_MESSAGES: 'Retrieving Bulletin Board messages',
  GET_FAQ_MESSAGES: 'Retrieving Faqs',
  ADD_BULLETIN_BOARD_MSG: 'Adding Bulletin board message',
  UPDATE_BULLETIN_BOARD_MSG: 'Updating Bulletin board message',
  ADD_FAQ_MSG: 'Adding Faq message',
  UPDATE_FAQ_MSG: 'Updating Faq message',
  GET_TRAINING_SCHEDULE: 'Retrieving Training Schedule',
  ADD_TRAINING_SCHEDULE_MSG: 'Adding Training Schedule',
  UPDATE_TRAINING_SCHEDULE_MSG: 'Updating Training Schedule',
  DELETE_TRAINING_SCHEDULE: 'Deleting Training Schedule',
  UPDATE_TRAINING_PRE_REGISTRATION: 'Training Pre-Registration updated successfully',
  GET_ICE_JOBS: 'Retrieving ICE jobs',
  CREATE_ICE_JOB: 'Creating ICE Job',
  CHANGE_PASSWORD_SUCCESS: 'Password has been change successfully',
  UPDATE_SEC_QS: 'Updating User Security Questions',
  UPDATE_DEFAULT_FACILITY: 'Updating Default Facility',
  PERFORM_SMOKE_TEST: 'Validating Smoke Test',
  VALIDATE_IMS_WEBSERVICE: 'Validating IMS Service',
  GET_USER_SECURITY_QUESTIONS: 'Retrieving User Security Questions',
  VERIFY_USER: 'Verifying User Details',
  UPDATE_PASSWORD: 'Updating Password',
  ACTIVATE_WEBSVC_ACCOUNT: 'Activating Web Service Account',
  ACTIVATE_CRUSH_FTP_ACCOUNT: 'Activating Crush FTP Account',
  GET_ADDRESS: 'Retrieving Address(es)',
  GET_FACILITY_ENROLLMENT: 'Retrieving Facility Enrollments',
  GET_USER_ENROLLMENT_LIST: 'Retrieving Users List',
  UPDATE_FACILITY_ENROLLMENT: 'Updating Facility Enrollment Information',
  UPDATE_USER_ENROLLMENT: 'Updating User Enrollment Information',
  CREATE_FACILITY: 'Creating Facility',
  UPDATE_USER_AGREEMENT: 'Saving User Confidential Agreement',
  GET_COVID_VACCINE_ENROLLMENT_LIST: 'Searching...',
  SUBMIT_NEW_USER_ENROLLMENT: 'Submitting New User Enrollment',
  GET_USER_ENROLLMENT: 'Retrieving User Enrollments',
  SUBMIT_IMM_48: 'Submitting IMM 48 Form',
  SEARCH_IMM_48: 'Retrieving IMM 48 Form(s)',
  DOWNLOAD_COVID_METRIC_REPORT: 'Downloading COVID-19 Metrics Report',
  DOWNLOAD_MONKEYPOX_METRIC_REPORT: 'Downloading Monkeypox Metrics Report',
  DOWNLOAD_COVID_STATS_REPORT: 'Downloading COVID-19 Stats Report',
  DOWNLOAD_COVID_VACCINE_SITE_REPORT: 'Downloading COVID-19 Vaccine Site Report',
  DOWNLOAD_COVID_VTRCKS_EXTRACT_REPORT: 'Downloading COVID-19 Vtrcks Extract',
  DOWNLOAD_COVID_CVRS_EXTRACT_REPORT: 'Downloading COVID-19 CVRS Extract',
  DOWNLOAD_MONKEYPOX_MVRS_EXTRACT_REPORT: 'Downloading Monkeypox MVRS Extract',
  DOWNLOAD_COVID_DOSE_REPORTED_OUTOF_NJVSS: 'Downloading COVID-19 Doses Reported Out of NJVSS Report',
  PLACE_MULTIPLE_ORDERS: 'Placing Multiple Order(s)',
  GET_FACILITY_TEMPERATURE_LOG: 'Retrieving Temperature Log(s)',
  ADD_ADVERSE_EVENT: 'Adding Adverse Event',
  UPDATE_ADVERSE_EVENT: 'Updating Adverse Event',
  DELETE_ADVERSE_EVENT: 'Deleting Adverse Event',
  GET_ORDER_STATUS: 'Retrieving Order(s)',
  DOWNLOAD_COVID_DOSE_EXTRACT: 'Downloading COVID-19 Doses Extract Report',
  DOWNLOAD_SMALLPOX_DOSE_EXTRACT: 'Downloading Smallpox Administered Extract Report',
  UPLOADING_KPI_FILE: 'Uploading file',
  GET_KPI_TRANSACTION: 'Retreiving KPI file list',
  GET_USER_COUNTY: 'Retrieving User County List',
  DOWNLOAD_INPROGRESS_COVID_CVRS_EXTRACT_REPORT: 'Download of COVID-19 CVRS Extract In Progress. Please wait... ',
  DOWNLOAD_INPROGRESS_MONKEYPOX_MVRS_EXTRACT_REPORT: 'Download of MONKEYPOX MVRS Extract In Progress. Please wait... ',
  TRANSFERING_STUDENTS: 'Transfer Students In Progress. Please wait..',
  DOWNLOAD_CDC_COVID_PROVIDER_EXTRACT_REPORT: 'Downloading COVID-19 Facility Extract',
  CLAIM_IMM48_FORM: 'Claiming IMM-48 Form',
  REJECTING_IMM48_FORM: 'Rejecting IMM-48 Form',
  APPROVE_IMM48_FORM: 'Approve IMM-48 Form',
  ACTIVATE_IMM48_FORM: 'Activating IMM-48 Form',
  RETRIEVING_INVENTORY_LIST: 'Retrieving Inventory List(s)',
  RETRIEVING_REVIEW_TRANSFER_LIST: 'Retrieving Review Transfer List(s)',
  UPDATE_INVENTORY_EXPIRATION_DETAILS: 'Updating Inventory Expiration Detail(s)',
  UPDATING_LOOKUP_VALUES: 'Updating Lookup Values',
  CDC_COVID_EXTRACT : 'CDC Covid Extract',
  CDC_COVID_PROVIDER_EXTRACT_REPORT : 'CDC Covid Provider Extract Report',
  CDC_RSV_EXTRACT: 'CDC RSV Extract',
  CDC_FLU_EXTRACT: 'CDC FLU Extract'
};

/**
 * Revaccinate Constants
 */
export const REVACCINATE = {
  INDIVIDUAL: 'INDIVIDUAL',
  COMBO: 'COMBO',
};

/**
 * Temperature Log Office Status Constants
 */
export const TEMP_LOG_OFFICE_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  MAINTENANCE: 'MAINTAINENCE',
};

/**
 * HL7 AUDIT Tool Constants
 */
export const HL7AUDIT = {
  SEARCH: 'SEARCH',
  VIEW_DETAIL_TXN: 'VIEW_DETAIL_TXN',
  VIEW_MSG_LIST: 'VIEW_MSG_LIST',
  VIEW_MSG_PROFILE: 'VIEW_MSG_PROFILE',
  VIEW_SUMMARY_AUDIT: 'VIEW_SUMMARY_AUDIT',
  VIEW_MSG_PROFILE_DETAIL: 'VIEW_MSG_PROFILE_DETAIL',
};

/**
 * Modes of COVID Vaccine Enrollment
 */
export const COVID_VACCINE_ENROLLMENT_MODES = {
  COVID_ADMIN_EDIT: 'COVID_ADMIN_EDIT',
  COVID_ENROLL: 'COVID_ENROLL',
};


export const STATE_FUND_ENROLLMENT_MODES = {
  STATE_FUND_ADMIN_EDIT: 'STATE_FUND_ADMIN_EDIT',
  STATE_FUND_ENROLL: 'STATE_FUND_ENROLL',
};

/**
 * VFC menus
 */
export const COVID_VACCINE_ENROLL_MENU = {
  COVID_MENU_ADMIN_EDIT: 'COVID_MENU_ADMIN_EDIT',
  COVID_MENU_ENROLL: 'COVID_MENU_ENROLL',
};

/**
 * VFC menus
 */
export const STATEFUND_ENROLL_MENU = {
  STATE_FUND_MENU_ADMIN_EDIT: 'STATE_FUND_MENU_ADMIN_EDIT',
  STATE_FUND_MENU_ENROLL: 'STATE_FUND_MENU_ENROLL',
};


/**
 * COVID-19 Enrollment mode constants
 */
export const COVID_VACCINE_ENROLLMENT_MODE = {
  ENROLLMENT: 'ENROLLMENT',
  ENROLLMGMT: 'ENROLLMGMT',
};

/**
 * COVID-19 Enrollment mode constants
 */
export const STATE_FUND_ENROLLMENT_MODE = {
  ENROLLMENT: 'ENROLLMENT',
  ENROLLMGMT: 'ENROLLMGMT',
};

/**
 * List of COVID Vaccine Enrollment Tabs column values
 */
export const COVID_VACCINE_ENROLL_COLUMN_VALUES = {
  FACILITY_TYPE: 'FACILITY_TYPE',
  ORG_IDENTIFICATION: 'ORG_IDENTIFICATION',
  VACC_COORDINATOR: 'VACC_COORDINATOR',
  OFFICE_INFO: 'OFFICE_INFO',
  VACCINE_DELIVERY: 'VACC_DELIVERY',
  POPULATION: 'POPULATION',
  THERMOMETER: 'THERMOMETER',
  STORAGE_UNIT: 'STORAGE_UNIT',
  LICENSED_MEDICAL_PHYSICIAN: 'LICENSED_MEDICAL_PHYSICIAN',
  AGREEMENT: 'AGREEMENT',
  REVIEW: 'REVIEW',
  COVID_PIN_MANAGEMENT: 'COVID_PIN_MANAGEMENT',
};

/**
 * List of State fund Enrollment Tabs column values
 */
export const STATE_FUND_ENROLL_COLUMN_VALUES = {
  FACILITY_TYPE: 'FACILITY_TYPE',
  ORG_IDENTIFICATION: 'ORG_IDENTIFICATION',
  VACC_COORDINATOR: 'VACC_COORDINATOR',
  OFFICE_INFO: 'OFFICE_INFO',
  VACCINE_DELIVERY: 'VACC_DELIVERY',
  POPULATION: 'POPULATION',
  THERMOMETER: 'THERMOMETER',
  STORAGE_UNIT: 'STORAGE_UNIT',
  LICENSED_MEDICAL_PHYSICIAN: 'LICENSED_MEDICAL_PHYSICIAN',
  AGREEMENT: 'AGREEMENT',
  REVIEW: 'REVIEW',
  PIN_MANAGEMENT: 'PIN_MANAGEMENT',
  ORDERING_FREQUENCY: 'ORDERING_FREQUENCY',
  VACCINE_ALLOWANCE: 'VACCINE_ALLOWANCE'


};

/**
 * List of request key for each of the tab in VFC
 */
export const COVID_VACCINE_ENROLL_MENU_TAB_REQUEST_KEY = {
  FACILITY_TYPE: 'facilityType',
  ORG_IDENTIFICATION: 'organizationIdentifier',
  VACC_COORDINATOR: 'vaccineCoordinator',
  OFFICE_INFO: 'office',
  VACCINE_DELIVERY: 'deliverySchedule',
  POPULATION: 'population',
  THERMOMETER: 'thermometer',
  STORAGE_UNIT: 'storageUnit',
  PHYSICIAN: 'physician',
  ASSOCIATED_OFFICE: 'associatedOffice',
  REVIEW: 'REVIEW',
  ORDERING_FREQUENCY: 'orderFrequency',
  VACCINE_ALLOWANCE: 'vaccineAllowanceList',
  COVID_PIN_MANAGEMENT: 'COVID_PIN_MANAGEMENT',
  AGREEMENT: 'agreement',
};

/**
 * covid vaccine enrollment tab name for MW apis
 */
export const COVID_VACCINE_ENROLL_MW_TAB_NAME = {
  GET_ORG_IDENTIFIER: 'GET_ORG_IDENTIFIER',
  GET_COVID_VACC_ENROLL_COORDINATOR: 'GET_COVID_VACC_ENROLL_COORDINATOR',
  GET_COVID_VACC_ENROLL_OFFICE: 'GET_COVID_VACC_ENROLL_OFFICE',
  GET_COVID_VACC_ENROLL_DELIVERY_SCHEDULE: 'GET_COVID_VACC_ENROLL_DELIVERY_SCHEDULE',
  GET_COVID_VACC_ENROLL_POPULATION: 'GET_COVID_VACC_ENROLL_POPULATION',
  GET_COVID_VACC_ENROLL_STORAGE_UNIT: 'GET_COVID_VACC_ENROLL_STORAGE_UNIT',
  GET_COVID_VACC_ENROLL_LICENSED_MEDICAL_PHYSICIAN: 'GET_COVID_VACC_ENROLL_LICENSED_MEDICAL_PHYSICIAN',
  GET_COVID_THERM_FILE: 'GET_COVID_THERM_FILE',
};

/**
 * covid vaccine enrollment tab name for MW apis
 */
export const STATEFUND_ENROLL_MW_TAB_NAME = {
  ORG_IDENTIFICATION: 'ORG_IDENTIFICATION',
  VACC_COORDINATOR: 'VACC_COORDINATOR',
  OFFICE_INFO: 'OFFICE_INFO',
  VACC_DELIVERY: 'VACC_DELIVERY',
  POPULATION: 'POPULATION',
  THERMOMETER: 'THERMOMETER',
  STORAGE_UNIT: 'STORAGE_UNIT',
  LICENSED_MEDICAL_PHYSICIAN: 'LICENSED_MEDICAL_PHYSICIAN',
  AGREEMENT: 'AGREEMENT'
};

/**
 * list of covid enrollment form status
 */
export const COVID_ENROLL_FORM_STATUS = {
  ADDITIONAL_STATUS: ['6', '7', '8'],
};

/**
 * Order workflow indicate if its from VFC or COVID
 */
export const ORDER_WORKFLOW = {
  VFC: 'VFC',
  COVID: 'COVID',
  STATE_FUND: 'STATE_FUND',
  COVID_MULTIPLE: 'COVID_MULTIPLE',
  STATE_FUND_MULTIPLE: 'STATE_FUND_MULTIPLE',
};

/**
 * date settings for reminder recall
 */
export const REMINDER_RECALL_DATE_SETTINGS = {
  REGULAR_REMINDER_RECALL: 'reminder.recall.date.settings',
  COVID_REMINDER_RECALL: 'covid.reminder.recall.date.settings',
};

/**
 * reminder recall type
 */
export const REMINDER_RECALL_TYPE = {
  REGULAR_REMINDER_RECALL: 'REGULAR',
  COVID_REMINDER_RECALL: 'COVID',
};

/**
 * CVRS Extract File Status
 */
 export const CVRS_EXTRACT_FILE_STATUS = {
  FILE_READY_TO_DOWNLOAD: 'FILE READY TO DOWNLOAD',
  FILE_PROCESSING: 'FILE PROCESSING',
  ERROR_PROCESSING: 'ERROR PROCESSING',
};
/**
 * MVRS Extract File Status
 */
 export const MVRS_EXTRACT_FILE_STATUS = {
  FILE_READY_TO_DOWNLOAD: 'FILE READY TO DOWNLOAD',
  FILE_PROCESSING: 'FILE PROCESSING',
  ERROR_PROCESSING: 'ERROR PROCESSING',
};
